import ROUTES from './routeConfig'
import RenderRoutes from './RenderRoutes'

export {
    RenderRoutes,
}

export default ROUTES
